<template>
  <div class="card-show inline-block align-left px-15-xs shadow">
    <br /><br /><br /><br class="hide-xs" /><br class="hide-xs" />
    <div class="flex items-center">
      <img :src="require('@/assets/img/icons/card_brands/' + card.brand + '.png')" alt="" />
      <span class="font-h4 mx-10 pt-5 font-body-xs">**** **** **** </span>
      <span class="font-h4 font-h6-xs">{{ card.last4 }}</span>
    </div>
    <br />
    <div class="align-center">
      <Dropdown :maxHeight="'0'" :position="'top-middle'" ref="updateCard">
        <template slot="toggle" @click="onUpdateCard">
          <button class="btn btn-primary font-h6 strong">
            <i class="la la-credit-card big-text mr-5" /> {{ $t("upgrade.update_credit_card") }}
          </button>
        </template>
        <template slot="content">
          <div class="pt-10 px-20 pb-5 align-left" style="width: 360px">
            <Card ref="card" />

            <button class="btn btn-large block btn-primary font-h6 mt-20 uppercase strong" v-ripple @click="submit">
              <i v-if="loading" class="la la-spinner spinning big-text mr-5"></i>
              <i v-else class="la la-credit-card big-text mr-5"></i>
              {{ $t("upgrade.update_card") }}
            </button>
          </div>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import request from "@/service";
import Card from "@/components/Upgrade/Card";
export default {
  name: "Update Card",
  components: {
    Card,
  },
  props: {
    card: {
      type: Object,
      default: {},
    },
  },
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
  },
  async mounted() {},
  methods: {
    async submit() {
      if (this.loading) return false;

      this.loading = true;
      const token = await this.$refs.card.createToken();

      if (token) {
        const responsePayment = await request("POST", "stripe/addPaymentMethod", {
          token: token,
        });

        if (responsePayment) {
          this.$root.$emit("alert", "Your new card has been updated!");
          this.$refs.updateCard.close();
          this.$emit("cardUpdated");
        } else {
          this.$root.$emit("alert", this.$t("upgrade.something_wrong"), "error");
        }
      }
      this.loading = false;
    },
  },
};
</script>
